<script setup lang="ts">
import type { Tone } from "@/lib/runState";

withDefaults(defineProps<{ tone: Tone; size?: number }>(), { size: 8 });
</script>

<template>
  <span class="dot" :data-tone="tone" :style="{ width: `${size}px`, height: `${size}px` }" aria-hidden="true" />
</template>

<style scoped>
.dot { display: inline-block; flex: none; border-radius: var(--radius-m); background: var(--faint); }
.dot[data-tone="working"] { background: var(--working); animation: pulse-ring 1.8s var(--ease) infinite; }
.dot[data-tone="attention"] { background: var(--attention); }
.dot[data-tone="done"] { background: var(--done); }
.dot[data-tone="failed"] { background: var(--failed); }
</style>
